import React, {useState, useEffect, useMemo} from 'react';
import styled, {useTheme} from 'styled-components';
import {useDispatch,useSelector} from 'react-redux';
import {useDraggable,useDroppable,useDndMonitor} from '@dnd-kit/core';
import {getTeamStrategy} from '../../../../../redux/selector/Team';
import {pitchPlayerPosition,teamSelectPlayerOnGameField,teamReplacePlayerFromTheirPosition,removePlayerFromStaff} from '../../../../../redux/actions/Team';
import {ratingRangeStatus} from '../../../../../service/constants';
import {simplifiedPosition,rangeColor,formRangeStatus,formRangeColor,ratingRangeAbbr,sortingPriority} from '../../../../../service/data';
import {strategyListDrop} from '../../../../../service/strategyListDrop';
import {cannotEnterXi, isSentOff, isSuspended, playerYellowCards} from '../../../../../service/matchEngine';
import {PitchStatusMarks} from '../../../../../components/MatchMarks';
import {getMyCurrentTeam,isPremiumUser} from '../../../../../redux/selector/User';
import {generalTeamRool} from './GameFields 3.0/data';
import {positionStyle} from '../positionStyle';
import {slotRoleStyle} from '../positionRoleStyle';
import {ReactComponent as DragIcon} from '../../../../../assets/img/drag-icon.svg';
import {StyledSortSelect,StrategySortMenuStyle} from '../../../../../components/ReplacePlayerList/styled';
import {fontUi} from '../../../../../theme/typography';
import {portalSelectStyles} from '../../../../../theme/selectStyles';
import {useStrategyPlayerMenu} from '../playerMenuContext';

const RECENT_SLOTS=5;

/* FM-style dense sheet: no nested card, full height, sticky chrome. */
const Panel=styled.section`
 ${fontUi};color:${({theme})=>theme.text};height:100%;box-sizing:border-box;display:flex;flex-direction:column;min-height:0;
 background:transparent;border:0;border-radius:0;overflow:hidden;
 .squad-tools {
   flex:none;display:flex;align-items:center;gap:8px;padding:0 0 8px;border-bottom:1px solid ${({theme})=>theme.borderSubtle};
 }
 .filters {display:flex;gap:3px;flex:1;min-width:0;}
 .filters button {
   flex:1;min-width:0;padding:6px 0;border:0;border-radius:${({theme})=>theme.controlRadius};
   color:${({theme})=>theme.textFaint};background:transparent;font:inherit;font-size:10px;font-weight:600;cursor:pointer;
 }
 .filters button:hover {color:${({theme})=>theme.text};background:${({theme})=>theme.hover};}
 .filters button[aria-pressed=true] {background:${({theme})=>theme.text};color:${({theme})=>theme.card};}
 .squad-tools .sort {width:118px;flex:0 0 118px;margin:0;font-size:11px;}
 .squad-tools .sort .react-select__control {
   min-height:30px;border:1px solid ${({theme})=>theme.border};border-radius:${({theme})=>theme.controlRadius};
   background:${({theme})=>theme.card};box-shadow:none;filter:none;
 }
 .squad-tools .sort .react-select__value-container {padding:0 6px;}
 .squad-tools .sort .react-select__single-value {font-size:11px;font-weight:600;}
 .squad-tools .sort .react-select__indicator {padding:2px 4px;}
 .squad-scroll {overflow:auto !important;overscroll-behavior:contain;min-height:0;flex:1;padding:0;}
 .column-labels {
   position:sticky;top:0;z-index:1;background:${({theme})=>theme.page || theme.card};
   font-size:9px;font-weight:600;letter-spacing:.02em;text-transform:uppercase;
   color:${({theme})=>theme.textFaint};padding:8px 4px 6px;border-bottom:1px solid ${({theme})=>theme.borderSubtle};
 }
 .column-labels,.squad-row {
   display:grid;grid-template-columns:10px 30px minmax(72px,1fr) minmax(26px,max-content) 22px 22px 22px 12px repeat(${RECENT_SLOTS}, 15px) 22px;
   gap:3px;align-items:center;
 }
 .column-labels .metric,.squad-row .metric {text-align:center;font-variant-numeric:tabular-nums;}
 .column-labels .recent-slot,.squad-row .recent-slot {text-align:center;font-variant-numeric:tabular-nums;font-size:10px;font-weight:600;width:15px;}
 .group-title {
   margin:0;padding:10px 4px 4px;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;
   color:${({theme})=>theme.textFaint};display:flex;justify-content:space-between;align-items:center;gap:8px;
 }
 .group-title .clear {border:0;padding:0;background:none;color:${({theme})=>theme.headerAccent};font:inherit;font-size:10px;font-weight:600;text-transform:none;letter-spacing:0;cursor:pointer;}
 .group-title span span {font-weight:600;opacity:.7;}
 .squad-row {
   min-height:38px;padding:4px;border-bottom:1px solid ${({theme})=>theme.borderSubtle};
   border-radius:0;font-size:12px;box-sizing:border-box;cursor:grab;touch-action:none;
 }
 .squad-row:hover {background:${({theme})=>theme.hover};}
 .squad-row[data-selected=true],.squad-row[data-over=true] {
   background:${({theme})=>theme.hover};box-shadow:inset 2px 0 0 ${({theme})=>theme.headerAccent};
 }
 .squad-row[data-dragging=true] {opacity:.4;}
 .squad-row > svg {width:9px;fill:${({theme})=>theme.textFaint};}
 .squad-row button {font:inherit;color:inherit;cursor:pointer;}
 /* Fixed box + grid centering — flex/baseline was leaving letters high. */
 .slot {
   display:grid;place-items:center;height:20px;width:100%;box-sizing:border-box;
   border:0;padding:0;margin:0;border-radius:2px;background:transparent;
   font:inherit;cursor:pointer;
 }
 .slot .slot-label {
   display:block;line-height:1;font-size:10px;font-weight:700;letter-spacing:.02em;
   font-variant-numeric:tabular-nums;transform:translateY(0.5px);
 }
 .slot[data-empty='true'] {color:${({theme})=>theme.textFaint};}
 .slot[data-empty='true'] .slot-label {font-weight:500;}
 .status {display:flex;align-items:center;justify-content:flex-start;gap:3px;min-height:16px;min-width:26px;line-height:0;}
 .status svg {width:auto;flex-shrink:0;}
 .name {border:0;padding:0;background:none;text-align:left;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600;}
 .name small {display:block;color:${({theme})=>theme.textFaint};font-size:9px;font-weight:500;min-width:0;overflow:hidden;text-overflow:ellipsis;}
 .action {
   width:22px;height:22px;padding:0;border:1px solid ${({theme})=>theme.border};
   background:${({theme})=>theme.card};border-radius:${({theme})=>theme.controlRadius};font-size:15px !important;line-height:1;
 }
 .action:disabled {opacity:.3;cursor:default;}
 .action[data-add=true] {color:${({theme})=>theme.success};}
 .action[data-swap=true] {color:#b8860b;font-size:11px !important;font-weight:700;}
 .fitness {width:7px;height:7px;border-radius:50%;margin:auto;}
 .bench-drop {min-height:24px;}
 .bench-drop[data-over=true] {outline:2px dashed ${({theme})=>theme.headerAccent};outline-offset:-2px;}
 .hint {font-size:10px;color:${({theme})=>theme.textFaint};padding:8px 4px;}
 .xi-count {margin-left:auto;font-size:10px;font-weight:600;color:${({theme})=>theme.textFaint};white-space:nowrap;}
`;

const groups={ALL:null,GK:['GK'],DEF:['LB','RB','CB'],MID:['DM','CM','LM','RM','CAM'],FWD:['LW','RW','ST']};
const sorts=[
  {value:'position',label:'Position'},
  {value:'name',label:'Name: A–Z'},
  {value:'age',label:'Age: youngest'},
  {value:'rating_range',label:'Rating: highest'},
  {value:'potential_range',label:'Potential: highest'},
  {value:'form_range',label:'Fitness: highest'},
];
const positionRank=(player)=>sortingPriority[simplifiedPosition[player?.fav_position] || player?.fav_position] ?? -1;
const recentColor=(value)=>value>=9?'#5386fa':value>=7?'#00bd83':'#edae35';
const slotLabel=(slot)=>simplifiedPosition[slot] || slot;
const playerPositions=(player)=>{
  const fav=simplifiedPosition[player?.fav_position] || player?.fav_position;
  const second=simplifiedPosition[player?.second_fav_position] || player?.second_fav_position;
  return {fav,second};
};
const canPlaySlot=(player,slot)=>{
  if(!player || !slot)return false;
  const need=slotLabel(slot);
  const {fav,second}=playerPositions(player);
  return fav===need || (second && second===need);
};
const positionMeta=(player,premium)=>{
  const {fav,second}=playerPositions(player);
  let pos=fav || '–';
  if(premium && second && second!==fav)pos=`${fav}/${second}`;
  if(premium){
    const style=player?.fav_style;
    if(style)return `${pos} · ${style}`;
  }
  return pos;
};
const comparePlayers=(a,b,sort)=>{
  if(sort.value==='name')return `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
  if(sort.value==='position')return positionRank(b)-positionRank(a) || `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
  if(sort.value==='age')return a.age-b.age;
  return (b[sort.value]??-1)-(a[sort.value]??-1);
};
const matchesFilter=(player,filter)=>{
  if(!groups[filter])return true;
  const {fav,second}=playerPositions(player);
  return groups[filter].includes(fav) || (second && groups[filter].includes(second));
};

function SquadRow({
  player,
  slot,
  selected,
  onSelect,
  onFocus,
  onAction,
  target,
  disabled,
  sentOff,
  isCaptain,
  premium,
  actionKind,
  inLineup,
}) {
  const enterBlocked=player && cannotEnterXi(player);
  const dragLocked=!player || disabled || (!slot && !inLineup && enterBlocked);
  const drag=useDraggable({id:`${player?._id || `empty-${slot}`} sidebar`,disabled:dragLocked});
  const drop=useDroppable({
    id:slot?`list-slot:${slot}`:`list-bench:${player._id}`,
    data:slot?{slot}:{bench:true,playerId:player._id},
  });
  const name=player?`${player.first_name} ${player.last_name}`:'Empty position';
  const rating=ratingRangeStatus[player?.rating_range];
  const potential=ratingRangeStatus[player?.potential_range];
  const fitness=formRangeStatus[player?.form_range];
  const recent=[...(player?.media_rating || [])].reverse().slice(0,RECENT_SLOTS);
  const yellows=playerYellowCards(player);
  const suspended=isSuspended(player);
  const injured=Number(player?.form_range)===-1 || player?.injured;
  const statusBits=[injured && 'Injured',suspended && 'Suspended',sentOff && 'Sent off',isCaptain && 'Captain',yellows>0 && `${yellows} yellow`].filter(Boolean).join(' · ');
  const kind=actionKind || (slot?'remove':'add');
  const actionSymbol=kind==='remove'?'−':kind==='swap'?'⇄':'+';
  const actionLabel=kind==='remove'
    ?`Remove ${name} from lineup`
    :kind==='swap'
      ?`Swap ${name} into ${target || 'lineup'}`
      :`Add ${name} to ${target || 'lineup'}`;
  const actionTitle=sentOff
    ?'Sent-off players stay on the pitch'
    :kind==='remove'
      ?'Move to remaining squad'
      :kind==='swap'
        ?`Swap into ${target}`
        :target
          ?`Use at ${target}`
          :'Select a position first';
  // Pos = current pitch slot only (XI row / empty slot). Bench shows "–".
  const resolvedSlot=slot || (inLineup && player?.current_position) || null;
  const slotDisplay=resolvedSlot ? slotLabel(resolvedSlot) : '–';
  const onPitch=!!resolvedSlot;
  const {open:openPlayerMenu}=useStrategyPlayerMenu();

  return (
    <div
      className="squad-row"
      data-selected={selected}
      data-over={drop.isOver}
      data-dragging={drag.isDragging}
      ref={(node)=>{drag.setNodeRef(node);drop.setNodeRef(node);}}
      {...drag.attributes}
      {...drag.listeners}
      onDragStart={(e)=>e.preventDefault()}
      onContextMenu={(e)=>{
        if(!player)return;
        e.preventDefault();
        e.stopPropagation();
        openPlayerMenu({
          x:e.clientX,
          y:e.clientY,
          player,
          slot:resolvedSlot,
          inXi:onPitch && !!player,
        });
      }}
    >
      <DragIcon aria-hidden="true"/>
      <button
        className="slot"
        type="button"
        data-empty={String(!onPitch)}
        style={onPitch ? slotRoleStyle(slotDisplay) : undefined}
        disabled={!slot && !onFocus && (!target || disabled || enterBlocked)}
        onClick={onSelect}
        title={slot?`Select ${slot}`:onPitch?`Select ${slotDisplay}`:'Not in the XI'}
      >
        <span className="slot-label">{slotDisplay}</span>
      </button>
      <button
        className="name"
        type="button"
        onClick={player?(onFocus || onSelect):onSelect}
        title={statusBits?`${name} — ${statusBits}`:name}
      >
        {name}
        {player && <small>{positionMeta(player,premium)}</small>}
      </button>
      <span className="status" aria-hidden={!player || !statusBits}>
        {player && (
          <PitchStatusMarks
            inline
            injured={injured}
            suspended={suspended}
            yellowCards={yellows}
            sentOff={sentOff}
            isCaptain={isCaptain}
          />
        )}
      </span>
      <span className="metric">{player?.age || '–'}</span>
      <span className="metric" title={`Rating: ${rating || 'Unavailable'}`} style={{color:rangeColor[rating]}}>{ratingRangeAbbr[rating] || '–'}</span>
      <span className="metric" title={`Potential: ${potential || 'Unavailable'}`} style={{color:rangeColor[potential]}}>{ratingRangeAbbr[potential] || '–'}</span>
      <span className="fitness" aria-label={`Fitness: ${fitness || 'Unavailable'}`} title={fitness} style={{background:formRangeColor[fitness] || 'transparent'}}/>
      {Array.from({length:RECENT_SLOTS},(_,i)=>{
        const value=recent[i];
        return <span key={i} className="recent-slot" style={{color:value==null?undefined:recentColor(value)}}>{value ?? ''}</span>;
      })}
      <button
        type="button"
        className="action"
        data-add={kind==='add'}
        data-swap={kind==='swap'}
        disabled={!player || disabled || (kind!=='remove' && enterBlocked) || sentOff || (kind==='add' && !target)}
        onClick={onAction}
        aria-label={actionLabel}
        title={actionTitle}
      >
        {actionSymbol}
      </button>
    </div>
  );
}

export default function StrategySquad({loading}) {
  const strategy=useSelector(getTeamStrategy);
  const dispatch=useDispatch();
  const theme=useTheme();
  const teamInfo=useSelector(getMyCurrentTeam);
  const premium=useSelector(isPremiumUser);
  const userTeamId=teamInfo?._id || teamInfo?.id;
  const {
    majorStaff:squad,
    allTeam:players,
    currentStrategy:formation,
    clickedPitchPlayerPosition:selected,
    matchRunning,
    captain,
  }=strategy;
  const [filter,setFilter]=useState('ALL');
  const [sort,setSort]=useState(sorts[0]);
  const benchDrop=useDroppable({id:'list-bench',data:{bench:true}});
  const slots=useMemo(()=>Object.keys(generalTeamRool[formation] || {}).sort((a,b)=>{
    const all=Object.keys(generalTeamRool[formation]);
    const x=positionStyle(a,all);
    const y=positionStyle(b,all);
    return parseFloat(x['--pitch-depth'])-parseFloat(y['--pitch-depth']) || parseFloat(x.left)-parseFloat(y.left);
  }),[formation]);
  const ids=new Set(squad.map((p)=>p._id));
  const empty=slots.filter((slot)=>!squad.some((p)=>p.current_position===slot));
  const captainId=captain?.player?._id;
  const selectedPlayer=selected?squad.find((p)=>p.current_position===selected):null;
  const selectedSentOff=selectedPlayer && isSentOff(selectedPlayer._id,matchRunning,userTeamId);
  const sortByPosition=sort.value==='position';
  const showXiGroup=sortByPosition && !selected;

  useEffect(()=>{
    setFilter(Object.keys(groups).find((key)=>groups[key]?.includes(simplifiedPosition[selected])) || 'ALL');
  },[selected]);

  const place=(player,position)=>{
    if(cannotEnterXi(player) && player?._id!==selectedPlayer?._id)return;
    if(selectedSentOff && selected)return;
    dispatch(teamSelectPlayerOnGameField({_id:selectedPlayer?._id,current_position:position}));
    dispatch(teamReplacePlayerFromTheirPosition(player));
    dispatch(pitchPlayerPosition(null));
  };

  useDndMonitor({onDragEnd({active,over}){
    if(strategy.isAutoFormatLoading)return;
    const change=strategyListDrop(active.id,over?.data.current,squad,players,{matchRunning,userTeamId});
    if(change?.remove)dispatch(removePlayerFromStaff(change.remove));
    else if(change)place(change.player,change.position);
  }});

  const toggleSlot=(slot)=>{
    dispatch(pitchPlayerPosition(selected===slot?null:slot));
  };

  /** Browse mode only (no slot selected): open that player's slot / a matching empty one. */
  const focusPlayer=(player)=>{
    if(!player)return;
    if(player.current_position && ids.has(player._id)){
      toggleSlot(player.current_position);
      return;
    }
    const fav=simplifiedPosition[player.fav_position] || player.fav_position;
    const matching=slots.filter((slot)=>slotLabel(slot)===fav);
    // Empty matching first; occupied matching next (swap filter); else any empty slot.
    const focus=matching.find((slot)=>empty.includes(slot)) || matching[0] || empty[0] || null;
    if(!focus)return;
    toggleSlot(focus);
  };

  /** Slot already selected: name click places / swaps into it (same as + / ⇄). */
  const pickForSelected=(player)=>{
    if(!player || !selected)return;
    if(selectedPlayer && String(selectedPlayer._id)===String(player._id)){
      dispatch(pitchPlayerPosition(null));
      return;
    }
    if(selectedSentOff)return;
    if(cannotEnterXi(player))return;
    place(player,selected);
  };

  const sortList=(list)=>[...list].sort((a,b)=>comparePlayers(a,b,sort));

  const filtered=useMemo(
    ()=>players.filter((p)=>matchesFilter(p,filter)),
    [players,filter]
  );

  const flatList=useMemo(()=>sortList(filtered),[filtered,sort]);

  const bench=sortList(filtered.filter((p)=>!ids.has(p._id)));

  const recommended=useMemo(()=>{
    if(!selected)return [];
    const eligible=filtered.filter((p)=>canPlaySlot(p,selected));
    const inXi=sortList(eligible.filter((p)=>ids.has(p._id)));
    const out=sortList(eligible.filter((p)=>!ids.has(p._id)));
    return [...inXi,...out];
  // eslint-disable-next-line react-hooks/exhaustive-deps -- ids is derived from squad each render
  },[selected,filtered,squad,sort]);

  return (
    <Panel aria-label="Squad selection">
      <StrategySortMenuStyle/>
      <div className="squad-tools">
        <div className="filters" role="group" aria-label="Position filter">
          {Object.keys(groups).map((key)=>(
            <button type="button" key={key} aria-pressed={filter===key} onClick={()=>setFilter(key)}>
              {key}
            </button>
          ))}
        </div>
        <span className="xi-count" title="Starting XI filled">
          XI {squad.length}/11
        </span>
        <StyledSortSelect
          className="sort"
          aria-label="Sort squad"
          classNamePrefix="react-select"
          options={sorts}
          value={sort}
          onChange={setSort}
          isSearchable={false}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuPlacement="auto"
          styles={portalSelectStyles(theme)}
        />
      </div>
      <div className="squad-scroll">
        <div className="column-labels">
          <span/>
          <span>Pos</span>
          <span>Player</span>
          <span aria-hidden="true"/>
          <span className="metric">Age</span>
          <span className="metric" title="Rating">Rat</span>
          <span className="metric" title="Potential">Pot</span>
          <span title="Fitness">Fit</span>
          {Array.from({length:RECENT_SLOTS},(_,i)=>(
            <span key={i} className="recent-slot" title="Last 5 match ratings">{i===0?'L5':''}</span>
          ))}
          <span/>
        </div>

        {showXiGroup && (
          <>
            <h4 className="group-title">Starting XI <span>{squad.length}/11</span></h4>
            {slots.map((slot)=>{
              const player=squad.find((p)=>p.current_position===slot);
              const sentOff=player && isSentOff(player._id,matchRunning,userTeamId);
              return (
                <SquadRow
                  key={slot}
                  slot={slot}
                  player={player}
                  premium={premium}
                  selected={selected===slot}
                  disabled={strategy.isAutoFormatLoading}
                  sentOff={sentOff}
                  isCaptain={captainId && player && String(captainId)===String(player._id)}
                  onSelect={()=>toggleSlot(slot)}
                  onFocus={player?()=>focusPlayer(player):undefined}
                  onAction={()=>{
                    if(!player || sentOff)return;
                    dispatch(removePlayerFromStaff(player._id));
                  }}
                />
              );
            })}
          </>
        )}

        <div ref={benchDrop.setNodeRef} className="bench-drop" data-over={benchDrop.isOver}>
          {selected ? (
            <>
              <h4 className="group-title">
                <span>For {slotLabel(selected)} <span>{recommended.length}</span></span>
                <button type="button" className="clear" onClick={()=>dispatch(pitchPlayerPosition(null))}>
                  Clear
                </button>
              </h4>
              {recommended.map((player)=>{
                const inLineup=ids.has(player._id);
                const isCurrent=selectedPlayer && String(selectedPlayer._id)===String(player._id);
                const sentOff=isSentOff(player._id,matchRunning,userTeamId);
                const kind=isCurrent?'remove':inLineup?'swap':'add';
                return (
                  <SquadRow
                    key={`rec-${player._id}`}
                    player={player}
                    premium={premium}
                    selected={isCurrent}
                    inLineup={inLineup}
                    target={selected}
                    actionKind={kind}
                    disabled={strategy.isAutoFormatLoading || selectedSentOff || (kind!=='remove' && cannotEnterXi(player))}
                    sentOff={sentOff}
                    isCaptain={captainId && String(captainId)===String(player._id)}
                    onSelect={()=>pickForSelected(player)}
                    onFocus={()=>pickForSelected(player)}
                    onAction={()=>{
                      if(sentOff && kind==='remove')return;
                      if(kind==='remove')dispatch(removePlayerFromStaff(player._id));
                      else place(player,selected);
                    }}
                  />
                );
              })}
              <p className="hint">
                {loading
                  ?'Loading players…'
                  :!recommended.length
                    ?'No players fit this position.'
                    :'Click a name to place or swap. − sends the current player to the squad.'}
              </p>
            </>
          ) : sortByPosition ? (
            <>
              <h4 className="group-title">Squad <span>{bench.length}</span></h4>
              {bench.map((player)=>{
                const target=empty.find((slot)=>slotLabel(slot)===(simplifiedPosition[player.fav_position] || player.fav_position)) || empty[0];
                return (
                  <SquadRow
                    key={player._id}
                    player={player}
                    premium={premium}
                    target={target}
                    disabled={strategy.isAutoFormatLoading || cannotEnterXi(player)}
                    isCaptain={captainId && String(captainId)===String(player._id)}
                    onSelect={()=>focusPlayer(player)}
                    onFocus={()=>focusPlayer(player)}
                    onAction={()=>place(player,target)}
                  />
                );
              })}
              <p className="hint">
                {loading
                  ?'Loading players…'
                  :!bench.length
                    ?'No matching players.'
                    :'Click a pitch slot or player to filter by position.'}
              </p>
            </>
          ) : (
            <>
              <h4 className="group-title">
                All players <span>{flatList.length}</span>
              </h4>
              {flatList.map((player)=>{
                const inLineup=ids.has(player._id);
                const target=empty.find((slot)=>slotLabel(slot)===(simplifiedPosition[player.fav_position] || player.fav_position)) || empty[0];
                const sentOff=isSentOff(player._id,matchRunning,userTeamId);
                const kind=inLineup?'remove':'add';
                return (
                  <SquadRow
                    key={player._id}
                    player={player}
                    premium={premium}
                    inLineup={inLineup}
                    target={target}
                    actionKind={kind}
                    disabled={strategy.isAutoFormatLoading || (!inLineup && cannotEnterXi(player))}
                    sentOff={sentOff}
                    isCaptain={captainId && String(captainId)===String(player._id)}
                    onSelect={()=>focusPlayer(player)}
                    onFocus={()=>focusPlayer(player)}
                    onAction={()=>{
                      if(sentOff && kind==='remove')return;
                      if(kind==='remove')dispatch(removePlayerFromStaff(player._id));
                      else if(target)place(player,target);
                    }}
                  />
                );
              })}
              <p className="hint">
                {loading
                  ?'Loading players…'
                  :!flatList.length
                    ?'No matching players.'
                    :'Filled slots show as dark Pos badges. Sorted as one list — no XI group.'}
              </p>
            </>
          )}
        </div>
      </div>
    </Panel>
  );
}
